<div
  class="flex flex-col items-start w-full p-8 my-10 bg-white address-content rounded-2xl">
  <h2 class="mb-2 text-2xl font-bold text-gray-900 font-raleway">
    Are you covered by our services?
  </h2>
  <p class="mb-4 text-base font-normal leading-6 text-gray-900 font-raleway">
    Enter the address where your internet service will be installed.
  </p>

  <div class="w-full">
    <label
      for="town"
      class="block mb-1 text-sm font-medium text-gray-700 font-raleway">
      Address
    </label>
      <p-autocomplete
        id="line1"
        [(ngModel)]="address()!.line1"
        optionLabel="streetLine"
        (onSelect)="addressSelected($event)"
        [suggestions]="addressOptions"
        (completeMethod)="searchAddress($event)" 
         class="w-full p-3 text-base text-gray-700 border border-gray-300 rounded-md" />
  </div>

  <div class="w-full">
    <label
      for="town"
      class="block mb-1 text-sm font-medium text-gray-700 font-raleway">
      Town
    </label>
    <input
      pInputText
      id="town"
      [(ngModel)]="address()!.town"
      class="w-full p-3 text-base text-gray-700 border border-gray-300 rounded-md" />
  </div>

  <div class="w-full">
    <label
      for="state"
      class="block mb-1 text-sm font-medium text-gray-700 font-raleway">
      State
    </label>
    <input
      pInputText
      id="state"
      [(ngModel)]="address()!.state"
      class="w-full p-3 text-base text-gray-700 border border-gray-300 rounded-md" />
  </div>

  <div class="w-full">
    <label
      for="zip-code"
      class="block mb-1 text-sm font-medium text-gray-700 font-raleway">
      Zip Code
    </label>
    <input
      pInputText
      id="zip-code"
      [(ngModel)]="address()!.postal_code"
      class="w-full p-3 text-base text-gray-700 border border-gray-300 rounded-md" />
  </div>

  <!--   Submit Button
  <div class="mt-6 text-center md:text-right">
    <button
      type="submit"
      class="w-40 h-12 px-6 py-3 text-sm font-medium text-white transition bg-blue-600 rounded-lg font-raleway hover:bg-blue-700"
      (click)="showDialog()">
      See Plans
      <i class="ml-2 pi pi-arrow-right"></i>
    </button>
  </div>
 -->
</div>

<div class="flex justify-center address-dialog">
  <p-dialog
    header="Verify address location"
    [modal]="true"
    [(visible)]="visible"
    [style]="{ width: '519px' }">
    <div class="px-4 modal-content">
      <p class="text-sm font-normal leading-6 text-gray-500 font-raleway">
        If needed, drag and drop the pin to the exact location of your service
        address.
      </p>
      <div class="w-full h-[463px] rounded-3xl overflow-hidden mt-5 mb-3">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7588297.056479287!2d-105.3340263140338!3d38.65557363320672!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54eab584e432360b%3A0x1c3bb99243deb742!2sUnited%20States!5e0!3m2!1sen!2sbd!4v1736559924759!5m2!1sen!2sbd"
          class="w-full h-full border-none"
          allowfullscreen
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"></iframe>
      </div>
    </div>

    <div class="flex items-center justify-between gap-2 px-4 my-4">
      <button
        (click)="visible = false"
        type="button"
        class="flex items-center justify-center gap-2 px-5 py-2 text-sm font-medium leading-6 text-gray-700 border border-gray-300 rounded-lg font-raleway">
        Enter Another Address
      </button>
      <button
        (click)="handleRoute()"
        type="button"
        class="flex items-center justify-center gap-2 px-5 py-2 text-sm font-medium leading-6 text-white bg-blue-600 rounded-lg font-raleway">
        Confirm Location
      </button>
    </div>
  </p-dialog>
</div>
